/** `oreas` translations, for every locale: the Inventory OREAS tab and the public stock page. */
export const oreas = {
  mn: {
    oreas: {
      tab: 'OREAS',
      help: 'OREAS стандарт дээжийн жагсаалт. Энд засвал нийтийн хуудас шууд шинэчлэгдэнэ.',
      add: 'Бүтээгдэхүүн нэмэх',
      rowActions: 'Үйлдэл',
      newTitle: 'Шинэ бүтээгдэхүүн',
      editTitle: 'Бүтээгдэхүүн засах',
      edit: 'Засах',
      search: 'Код, материал эсвэл элементээр хайх',
      loadFailed: 'OREAS жагсаалтыг ачаалж чадсангүй',
      saveFailed: 'Бүтээгдэхүүнийг хадгалж чадсангүй:',
      saved: 'Хадгалагдлаа',
      delete: 'Устгах',
      deleteFailed: 'Бүтээгдэхүүнийг устгаж чадсангүй:',
      deleted: 'Устгагдлаа',
      none: 'Бүтээгдэхүүн алга',
      noMatch: 'Хайлтад тохирох бүтээгдэхүүн алга',
      stockTotal: 'Нийт нөөц',
      incomingTotal: 'Нийт ирж буй',
      notSet: 'Тодорхойгүй',
      inactive: 'Идэвхгүй',
      embed: 'Өөр сайтад оруулах код',
      feed: 'JSON өгөгдлийн хаяг',
      page: 'Нийтийн хуудас',
      copy: 'Хуулах',
      copied: 'Хуулагдлаа',
      copyFailed: 'Хуулж чадсангүй. Текстийг сонгоод гараар хуулна уу.',
      working: 'Хадгалж байна…',
      field: {
        code: 'Код',
        price: 'Үнэ, ₮, НӨАТ орсон',
        stock: 'Нөөцөд байгаа тоо',
        incoming: 'Ирж буй тоо',
        material: 'Материал',
        depositType: 'Ордын төрөл',
        link: 'Гэрчилгээний холбоос',
        active: 'Нийтийн хуудсанд харуулах',
      },
      error: {
        content: 'Мөр бүрт элемент болон тоон утга оруулна уу.',
        code: 'Код оруулна уу.',
        price: 'Үнэ нь тэгээс багагүй тоо байх ёстой, жишээ нь 17000.',
        quantity: 'Тоо нь 0-ээс 100000 хүртэлх бүхэл тоо байх ёстой.',
        link: 'Холбоос http:// эсвэл https://-ээр эхэлсэн, хоосон зайгүй байх ёстой.',
      },
      content: {
        title: 'Агуулга',
        none: 'Гэрчилгээжсэн утга алга.',
        row: 'Мөр',
        asTyped: 'Бичсэнээр нь',
        element: 'Элемент',
        newElement: 'Шинэ элемент',
        below: 'Бага (<)',
        amount: 'Утга',
        unit: 'Нэгж',
        remove: 'Хасах',
        add: 'Мөр нэмэх',
        full: 'Хамгийн ихдээ {{max}} мөр.',
      },
      values: {
        title: { material: 'Материалууд', deposit_type: 'Ордын төрлүүд' },
        public: 'Эдгээр утгууд олон нийтийн хуудсанд харагдана. Нэрийг өөрчилбөл тухайн утгатай бүх бүтээгдэхүүн өөр алхамгүйгээр шинэчлэгдэнэ. Ямар ч бүтээгдэхүүнд хэрэглээгүй утга нийтэд харагдахгүй.',
        mergeTitle: 'Зөвхөн том жижиг үсгээр ялгаатай',
        mergeHelp: 'Үлдээх бичлэгээ сонгоно уу. Сонгох хүртэл юу ч өөрчлөгдөхгүй.',
        keep: '{{label}}-г үлдээх ({{count}})',
        new: 'Шинэ утга',
        add: 'Нэмэх',
        typeFirst: 'Эхлээд утгаа бичнэ үү.',
        rename: 'Нэр өөрчлөх',
        remove: 'Устгах',
        inUse: 'Бүтээгдэхүүнд хэрэглэгдэж байгаа утгыг устгах боломжгүй.',
        used: 'Бүтээгдэхүүн: {{count}}',
        failed: 'Амжилтгүй боллоо:',
        loadFailed: 'Жагсаалтыг ачаалж чадсангүй.',
        none: 'Утга алга.',
        edit: 'Засах',
      },
      requests: {
        tabStock: 'Нөөц',
        tabRequests: 'Хүсэлтүүд',
        filter: 'Төлөв',
        loadFailed: 'Хүсэлтүүдийг ачаалж чадсангүй',
        none: 'Энэ төлөвтэй хүсэлт алга.',
        failed: 'Хийж чадсангүй.',
        kind: { need: 'Захиалга', contact: 'Холбогдох' },
        status: { new: 'Шинэ', resolved: 'Шийдсэн', rejected: 'Татгалзсан', closed: 'Хаасан', all: 'Бүгд' },
        askedAbout: '{{code}}-ийн талаар холбогдохыг хүссэн',
        asked: 'Хүссэн тоо',
        noPrice: '{{codes}}-д үнэ байхгүй. Үнийн саналын мөр 0 болно, үнийг нь үнийн санал дээр оруулна уу.',
        quotationGone: 'Энэ хүсэлтийн үнийн санал устсан.',
        draftQuotation: 'Ноорог үнийн санал',
        resolve: 'Үнийн санал гаргах',
        reject: 'Татгалзах',
        close: 'Хаах',
        resolveTitle: 'Ноорог үнийн санал гаргах',
        rejectTitle: '{{company}}-ийн хүсэлтээс татгалзах уу?',
        closeTitle: '{{company}}-ийн хүсэлтийг хаах уу?',
        client: 'Харилцагч',
        newClient: 'Шинэ харилцагч үүсгэх',
        clientSearch: 'Харилцагч хайх',
        issuer: 'Гаргагч компани',
        offer: {
          resolve: 'Ноорогт зориулж нөөцөөс хасах тоо',
          issue: 'Гаргасан үнийн саналд зориулж нөөцөөс хасах тоо',
          invoice: 'Нэхэмжлэхэд зориулж нөөцөөс хасах тоо',
        },
        accept: 'Нөөцөөс хасах',
        decline: 'Одоо биш',
        reduced: '{{qty}} ширхэгийг нөөцөөс хассан',
        givenBack: '{{qty}} ширхэгийг нөөцөд буцаасан',
        giveBackAsk: 'Баримт хүчингүй болсон. {{qty}} ширхэгийг нөөцөд буцаах уу?',
        giveBack: 'Нөөцөд буцаах',
        keep: 'Буцаахгүй',
        waiting: 'OREAS нөөц хариу хүлээж байна',
        waitingFilter: {
          search: 'Код эсвэл компаниар хайх',
          company: 'Компани',
          stage: 'Шат',
          allCompanies: 'Бүх компани',
          allStages: 'Бүх шат',
          noMatch: 'Хайлтад тохирох мөр алга.',
          clear: 'Шүүлтүүр цэвэрлэх',
          shownOf: '{{total}}-с {{shown}}',
        },
        done: {
          resolved: 'Ноорог үнийн санал гарлаа',
          rejected: 'Хүсэлтээс татгалзлаа',
          closed: 'Хүсэлтийг хаалаа',
          reduced: 'Нөөцөөс хаслаа',
          declined: 'Нөөц өөрчлөгдсөнгүй',
          gaveBack: 'Нөөцөд буцаалаа',
          kept: 'Нөөцөд буцаасангүй',
        },
        error: {
          name: 'Нэр оруулна уу.',
          company: 'Компанийн нэр оруулна уу.',
          phone: 'Утасны дугаар оруулна уу, жишээ нь 99112233.',
          email: 'Имэйл хаяг оруулна уу, жишээ нь name@company.mn.',
          quantity: '1-ээс 100000 хүртэлх бүхэл тоо оруулна уу.',
        },
        history: 'Түүх',
        historyTitle: '{{code}}-ийн нөөцийн түүх',
        historyNone: 'Нөөц одоогоор өөрчлөгдөөгүй.',
        when: 'Огноо',
        why: 'Шалтгаан',
        who: 'Хэн',
        source: {
          manual: 'Гараар зассан',
          created: 'Шинээр бүртгэсэн',
          void: 'Нөөцөд буцаасан',
          resolve: 'Хүсэлтийн ноорог',
          issue: 'Гаргасан үнийн санал',
          invoice: 'Нэхэмжлэх',
        },
      },
      public: {
        title: 'OREAS стандарт дээж',
        inStock: 'Монголд бэлэн байгаа',
        incoming: 'Ирж буй бүтээгдэхүүн',
        notFinal: 'Эдгээр бүтээгдэхүүний үнэ эцэслэгдээгүй байна.',
        product: 'Бүтээгдэхүүн',
        certified: 'Баталгаажсан утга',
        material: 'Материал',
        quantity: 'Тоо ширхэг',
        price: 'Үнэ, ₮, НӨАТ орсон',
        depositType: 'Ордын төрөл',
        askPrice: 'Үнэ лавлана уу',
        search: 'Код, материал эсвэл элементээр хайх',
        section: 'Хэсэг',
        yourRequest: 'Таны хүсэлт',
        unitExclVat: 'Нэгж үнэ, НӨАТ-гүй × тоо',
        amountMnt: 'Нийт үнэ, ₮',
        subtotal: 'Дүн',
        vat: 'НӨАТ ({{rate}})',
        total: 'Нийт дүн',
        notCounted: 'Нийт дүнд ороогүй: {{codes}}',
        noneSelected: 'Бүтээгдэхүүн сонгоогүй байна.',
        remove: '{{code}} хасах',
        ofAvailable: '{{max}}-с',
        showOther: '{{section}} харах: {{count}}',
        allMaterials: 'Бүх материал',
        allDeposits: 'Бүх ордын төрөл',
        analyte: 'Элемент',
        allAnalytes: 'Бүх элемент',
        addAnalyte: 'Элемент нэмэх',
        removeAnalyte: '{{analyte}} хасах',
        matchAnalytes: 'Бүтээгдэхүүнд байх ёстой',
        matchAll: 'Бүгд нь',
        matchAny: 'Аль нэг нь',
        least: 'доод',
        most: 'дээд',
        valueColumn: 'Баталгаажсан утга {{n}}',
        sortBy: 'Эрэмбэлэх',
        sortUp: 'Өсөхөөр эрэмбэлэх',
        sortDown: 'Буурахаар эрэмбэлэх',
        language: 'Хэл',
        clear: 'Шүүлтүүр арилгах',
        noMatch: 'Сонгосон шүүлтүүрт тохирох бүтээгдэхүүн алга.',
        emptyInStock: 'Одоогоор нөөцөд бүтээгдэхүүн алга.',
        emptyIncoming: 'Одоогоор ирж буй бүтээгдэхүүн алга.',
        loading: 'Ачаалж байна…',
        unavailable: 'Нөөцийн жагсаалт одоогоор нээгдэхгүй байна.',
        need: 'Хэрэгтэй',
        needOf: '{{code}}-с авах тоо',
        tickOf: '{{code}}-г сонгох',
        contact: 'Холбогдох',
        contactTitle: '{{code}}-ийн талаар холбогдох',
        requestTitle: 'Хүсэлт илгээх',
        selected_one: '{{count}} бүтээгдэхүүн сонгосон',
        selected_other: '{{count}} бүтээгдэхүүн сонгосон',
        send: 'Илгээх',
        sending: 'Илгээж байна…',
        cancel: 'Болих',
        sent: 'Хүсэлтийг хүлээн авлаа. Манай ажилтан тантай холбогдоно.',
        field: {
          name: 'Нэр',
          company: 'Компани',
          phone: 'Утас',
          email: 'Имэйл',
          registration: 'Регистрийн дугаар',
          address: 'Нэхэмжлэхийн хаяг',
          note: 'Тэмдэглэл',
        },
        error: {
          name: 'Нэрээ оруулна уу.',
          company: 'Компанийн нэрээ оруулна уу.',
          phone: 'Утасны дугаараа оруулна уу, жишээ нь 99112233.',
          email: 'Имэйл хаягаа оруулна уу, жишээ нь name@company.mn.',
          quantity: 'Тоо нь 1-ээс багагүй бүхэл тоо байх ёстой.',
          tooMany: 'Хамгийн ихдээ {{max}} ширхэг авах боломжтой.',
          gone: '{{code}} жагсаалтад байхгүй болсон. Сонголтоо арилгана уу.',
          noLines: 'Дор хаяж нэг бүтээгдэхүүн сонгоно уу.',
          busy: 'Хэт олон хүсэлт илгээлээ. Нэг минут хүлээгээд дахин оролдоно уу.',
          refused: 'Хүсэлтийг хүлээн авсангүй. Талбаруудаа шалгаад дахин оролдоно уу.',
          failed: 'Хүсэлтийг илгээж чадсангүй ({{status}}). Дахин оролдоно уу.',
        },
      },
    },
  },
  en: {
    oreas: {
      tab: 'OREAS',
      help: 'The OREAS reference materials. An edit here shows on the public page with no other step.',
      add: 'Add product',
      rowActions: 'Actions',
      newTitle: 'New product',
      editTitle: 'Edit product',
      edit: 'Edit',
      search: 'Search by code, material or element',
      loadFailed: 'Could not load the OREAS list',
      saveFailed: 'Could not save the product:',
      saved: 'Saved',
      delete: 'Delete',
      deleteFailed: 'Could not delete the product:',
      deleted: 'Deleted',
      none: 'No products yet',
      noMatch: 'No product matches this search',
      stockTotal: 'Total in stock',
      incomingTotal: 'Total incoming',
      notSet: 'Not set',
      inactive: 'Inactive',
      embed: 'Embed code for another site',
      feed: 'JSON feed address',
      page: 'Public page',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Could not copy. Select the text and copy it by hand.',
      working: 'Saving…',
      field: {
        code: 'Code',
        price: 'Price MNT, incl. VAT',
        stock: 'Quantity in stock',
        incoming: 'Quantity incoming',
        material: 'Material',
        depositType: 'Deposit type',
        link: 'Certificate link',
        active: 'Show on the public page',
      },
      error: {
        content: 'Each row needs an element and a number.',
        code: 'Enter the product code.',
        price: 'The price must be a number of zero or more, such as 17000.',
        quantity: 'The quantity must be a whole number from 0 to 100000.',
        link: 'The link must start with http:// or https:// and hold no spaces.',
      },
      content: {
        title: 'Content',
        none: 'No certified values yet.',
        row: 'Row',
        asTyped: 'As typed',
        element: 'Element',
        newElement: 'New element',
        below: 'Below (<)',
        amount: 'Value',
        unit: 'Unit',
        remove: 'Remove',
        add: 'Add row',
        full: 'At most {{max}} rows.',
      },
      values: {
        title: { material: 'Materials', deposit_type: 'Deposit types' },
        public: 'These values show on the public page. A rename changes every product holding the value, with no other step. A value no product holds is not public.',
        mergeTitle: 'Differ only in capitals',
        mergeHelp: 'Pick the spelling to keep. Nothing changes until you pick.',
        keep: 'Keep {{label}} ({{count}})',
        new: 'New value',
        add: 'Add',
        typeFirst: 'Type the value first.',
        rename: 'Rename',
        remove: 'Remove',
        inUse: 'A value on a product cannot be removed.',
        used: 'Products: {{count}}',
        failed: 'That did not go through:',
        loadFailed: 'Could not load the list.',
        none: 'No values yet.',
        edit: 'Edit list',
      },
      requests: {
        tabStock: 'Stock',
        tabRequests: 'Requests',
        filter: 'Status',
        loadFailed: 'Could not load the requests',
        none: 'No requests with this status.',
        failed: 'That did not go through.',
        kind: { need: 'Order', contact: 'Call back' },
        status: { new: 'New', resolved: 'Resolved', rejected: 'Rejected', closed: 'Closed', all: 'All' },
        askedAbout: 'Asked to be contacted about {{code}}',
        asked: 'Asked',
        noPrice: '{{codes}} has no price. The quotation line will be 0, so set the price on the quotation.',
        quotationGone: 'The quotation for this request was deleted.',
        draftQuotation: 'Draft quotation',
        resolve: 'Make quotation',
        reject: 'Reject',
        close: 'Close request',
        resolveTitle: 'Make a Draft quotation',
        rejectTitle: 'Reject the request from {{company}}?',
        closeTitle: 'Close the request from {{company}}?',
        client: 'Client',
        newClient: 'Make a new client',
        clientSearch: 'Search clients',
        issuer: 'Issuing company',
        offer: {
          resolve: 'Take off stock for the Draft',
          issue: 'Take off stock for the issued quotation',
          invoice: 'Take off stock for the invoice',
        },
        accept: 'Take off stock',
        decline: 'Not now',
        reduced: '{{qty}} taken off stock',
        givenBack: '{{qty}} given back to stock',
        giveBackAsk: 'The document was voided. Give {{qty}} back to stock?',
        giveBack: 'Give back',
        keep: 'Keep off stock',
        waiting: 'OREAS stock waiting for an answer',
        waitingFilter: {
          search: 'Search by code or company',
          company: 'Company',
          stage: 'Stage',
          allCompanies: 'All companies',
          allStages: 'All stages',
          noMatch: 'No waiting line matches.',
          clear: 'Clear filters',
          shownOf: '{{shown}} of {{total}}',
        },
        done: {
          resolved: 'Draft quotation made',
          rejected: 'Request rejected',
          closed: 'Request closed',
          reduced: 'Taken off stock',
          declined: 'Stock left as it is',
          gaveBack: 'Given back to stock',
          kept: 'Kept off stock',
        },
        error: {
          name: 'Enter a name.',
          company: 'Enter a company name.',
          phone: 'Enter a phone number, such as 99112233.',
          email: 'Enter an email address, such as name@company.mn.',
          quantity: 'Enter a whole number from 1 to 100000.',
        },
        history: 'History',
        historyTitle: 'Stock history of {{code}}',
        historyNone: 'The stock has not changed yet.',
        when: 'Date',
        why: 'Why',
        who: 'Who',
        source: {
          manual: 'Edited by hand',
          created: 'Product added',
          void: 'Given back',
          resolve: 'Draft from a request',
          issue: 'Issued quotation',
          invoice: 'Invoice',
        },
      },
      public: {
        title: 'OREAS reference materials',
        inStock: 'In stock in Mongolia',
        incoming: 'Incoming products',
        notFinal: 'Prices for these products are not final yet.',
        product: 'Product',
        certified: 'Certified values',
        material: 'Material',
        quantity: 'Quantity',
        price: 'Price MNT, incl. VAT',
        depositType: 'Deposit type',
        askPrice: 'Ask for price',
        search: 'Search by code, material or element',
        section: 'Section',
        yourRequest: 'Your request',
        unitExclVat: 'Unit price excl. VAT × quantity',
        amountMnt: 'Amount MNT',
        subtotal: 'Subtotal',
        vat: 'VAT ({{rate}})',
        total: 'Total',
        notCounted: 'Not in the total: {{codes}}',
        noneSelected: 'No products selected.',
        remove: 'Remove {{code}}',
        ofAvailable: 'of {{max}}',
        showOther: 'Show {{section}}: {{count}}',
        allMaterials: 'All materials',
        allDeposits: 'All deposit types',
        analyte: 'Element',
        allAnalytes: 'All elements',
        addAnalyte: 'Add element',
        removeAnalyte: 'Remove {{analyte}}',
        matchAnalytes: 'Products must hold',
        matchAll: 'All of these',
        matchAny: 'Any of these',
        least: 'min',
        most: 'max',
        valueColumn: 'Certified value {{n}}',
        sortBy: 'Sort by',
        sortUp: 'Sort ascending',
        sortDown: 'Sort descending',
        language: 'Language',
        clear: 'Clear filters',
        noMatch: 'No product matches these filters.',
        emptyInStock: 'Nothing in stock right now.',
        emptyIncoming: 'Nothing incoming right now.',
        loading: 'Loading…',
        unavailable: 'The stock list is not available right now.',
        need: 'Need',
        needOf: 'Quantity of {{code}}',
        tickOf: 'Select {{code}}',
        contact: 'Contact',
        contactTitle: 'Contact us about {{code}}',
        requestTitle: 'Send a request',
        selected_one: '{{count}} product selected',
        selected_other: '{{count}} products selected',
        send: 'Send',
        sending: 'Sending…',
        cancel: 'Cancel',
        sent: 'We have your request. Our staff will contact you.',
        field: {
          name: 'Name',
          company: 'Company',
          phone: 'Phone',
          email: 'Email',
          registration: 'Registration number',
          address: 'Billing address',
          note: 'Note',
        },
        error: {
          name: 'Enter your name.',
          company: 'Enter your company name.',
          phone: 'Enter a phone number, such as 99112233.',
          email: 'Enter an email address, such as name@company.mn.',
          quantity: 'Enter a whole number of at least 1.',
          tooMany: 'At most {{max}} are available.',
          gone: '{{code}} is no longer listed. Remove it to continue.',
          noLines: 'Select at least one product.',
          busy: 'Too many requests were sent. Wait a minute and try again.',
          refused: 'The request was refused. Check the fields and try again.',
          failed: 'The request could not be sent ({{status}}). Try again.',
        },
      },
    },
  },
  ru: {
    oreas: {
      tab: 'OREAS',
      help: 'Стандартные образцы OREAS. Изменение здесь сразу появляется на публичной странице.',
      add: 'Добавить продукт',
      rowActions: 'Действия',
      newTitle: 'Новый продукт',
      editTitle: 'Изменить продукт',
      edit: 'Изменить',
      search: 'Поиск по коду, материалу или элементу',
      loadFailed: 'Не удалось загрузить список OREAS',
      saveFailed: 'Не удалось сохранить продукт:',
      saved: 'Сохранено',
      delete: 'Удалить',
      deleteFailed: 'Не удалось удалить продукт:',
      deleted: 'Удалено',
      none: 'Продуктов пока нет',
      noMatch: 'Нет продуктов по этому запросу',
      stockTotal: 'Всего в наличии',
      incomingTotal: 'Всего ожидается',
      notSet: 'Не указано',
      inactive: 'Неактивен',
      embed: 'Код для вставки на другой сайт',
      feed: 'Адрес JSON-данных',
      page: 'Публичная страница',
      copy: 'Копировать',
      copied: 'Скопировано',
      copyFailed: 'Не удалось скопировать. Выделите текст и скопируйте вручную.',
      working: 'Сохранение…',
      field: {
        code: 'Код',
        price: 'Цена, MNT, с НДС',
        stock: 'Количество в наличии',
        incoming: 'Ожидаемое количество',
        material: 'Материал',
        depositType: 'Тип месторождения',
        link: 'Ссылка на сертификат',
        active: 'Показывать на публичной странице',
      },
      error: {
        content: 'В каждой строке нужны элемент и число.',
        code: 'Введите код продукта.',
        price: 'Цена должна быть числом не меньше нуля, например 17000.',
        quantity: 'Количество должно быть целым числом от 0 до 100000.',
        link: 'Ссылка должна начинаться с http:// или https:// и не содержать пробелов.',
      },
      content: {
        title: 'Содержание',
        none: 'Сертифицированных значений пока нет.',
        row: 'Строка',
        asTyped: 'Как введено',
        element: 'Элемент',
        newElement: 'Новый элемент',
        below: 'Менее (<)',
        amount: 'Значение',
        unit: 'Единица',
        remove: 'Убрать',
        add: 'Добавить строку',
        full: 'Не более {{max}} строк.',
      },
      values: {
        title: { material: 'Материалы', deposit_type: 'Типы месторождений' },
        public: 'Эти значения видны на публичной странице. Переименование меняет все продукты с этим значением без других шагов. Значение, которого нет ни у одного продукта, не публикуется.',
        mergeTitle: 'Различаются только регистром',
        mergeHelp: 'Выберите написание, которое останется. Пока вы не выбрали, ничего не меняется.',
        keep: 'Оставить {{label}} ({{count}})',
        new: 'Новое значение',
        add: 'Добавить',
        typeFirst: 'Сначала введите значение.',
        rename: 'Переименовать',
        remove: 'Удалить',
        inUse: 'Значение, указанное у продукта, удалить нельзя.',
        used: 'Продуктов: {{count}}',
        failed: 'Не удалось:',
        loadFailed: 'Не удалось загрузить список.',
        none: 'Значений пока нет.',
        edit: 'Изменить список',
      },
      requests: {
        tabStock: 'Запас',
        tabRequests: 'Заявки',
        filter: 'Статус',
        loadFailed: 'Не удалось загрузить заявки',
        none: 'Заявок с этим статусом нет.',
        failed: 'Не удалось выполнить.',
        kind: { need: 'Заказ', contact: 'Связаться' },
        status: { new: 'Новая', resolved: 'Решена', rejected: 'Отклонена', closed: 'Закрыта', all: 'Все' },
        askedAbout: 'Просит связаться по {{code}}',
        asked: 'Запрошено',
        noPrice: 'У {{codes}} нет цены. Строка предложения будет 0, укажите цену в предложении.',
        quotationGone: 'Коммерческое предложение по этой заявке удалено.',
        draftQuotation: 'Черновик предложения',
        resolve: 'Создать предложение',
        reject: 'Отклонить',
        close: 'Закрыть заявку',
        resolveTitle: 'Создать черновик предложения',
        rejectTitle: 'Отклонить заявку от {{company}}?',
        closeTitle: 'Закрыть заявку от {{company}}?',
        client: 'Клиент',
        newClient: 'Создать нового клиента',
        clientSearch: 'Поиск клиентов',
        issuer: 'Компания-выпускающий',
        offer: {
          resolve: 'Списать с запаса для черновика',
          issue: 'Списать с запаса для выпущенного предложения',
          invoice: 'Списать с запаса для счёта',
        },
        accept: 'Списать с запаса',
        decline: 'Не сейчас',
        reduced: 'Списано с запаса: {{qty}}',
        givenBack: 'Возвращено в запас: {{qty}}',
        giveBackAsk: 'Документ аннулирован. Вернуть {{qty}} в запас?',
        giveBack: 'Вернуть',
        keep: 'Не возвращать',
        waiting: 'Запас OREAS ждёт ответа',
        waitingFilter: {
          search: 'Поиск по коду или компании',
          company: 'Компания',
          stage: 'Этап',
          allCompanies: 'Все компании',
          allStages: 'Все этапы',
          noMatch: 'Нет подходящих строк.',
          clear: 'Сбросить фильтры',
          shownOf: '{{shown}} из {{total}}',
        },
        done: {
          resolved: 'Черновик предложения создан',
          rejected: 'Заявка отклонена',
          closed: 'Заявка закрыта',
          reduced: 'Списано с запаса',
          declined: 'Запас не изменён',
          gaveBack: 'Возвращено в запас',
          kept: 'Не возвращено в запас',
        },
        error: {
          name: 'Введите имя.',
          company: 'Введите название компании.',
          phone: 'Введите номер телефона, например 99112233.',
          email: 'Введите адрес эл. почты, например name@company.mn.',
          quantity: 'Введите целое число от 1 до 100000.',
        },
        history: 'История',
        historyTitle: 'История запаса {{code}}',
        historyNone: 'Запас пока не менялся.',
        when: 'Дата',
        why: 'Причина',
        who: 'Кто',
        source: {
          manual: 'Изменено вручную',
          created: 'Продукт добавлен',
          void: 'Возвращено',
          resolve: 'Черновик по заявке',
          issue: 'Выпущенное предложение',
          invoice: 'Счёт',
        },
      },
      public: {
        title: 'Стандартные образцы OREAS',
        inStock: 'В наличии в Монголии',
        incoming: 'Ожидаемые поступления',
        notFinal: 'Цены на эти продукты ещё не окончательные.',
        product: 'Продукт',
        certified: 'Сертифицированные значения',
        material: 'Материал',
        quantity: 'Количество',
        price: 'Цена, MNT, с НДС',
        depositType: 'Тип месторождения',
        askPrice: 'Цену уточняйте',
        search: 'Поиск по коду, материалу или элементу',
        section: 'Раздел',
        yourRequest: 'Ваш запрос',
        unitExclVat: 'Цена за ед. без НДС × кол-во',
        amountMnt: 'Сумма, MNT',
        subtotal: 'Итого',
        vat: 'НДС ({{rate}})',
        total: 'Итого с НДС',
        notCounted: 'Не вошло в итог: {{codes}}',
        noneSelected: 'Продукты не выбраны.',
        remove: 'Убрать {{code}}',
        ofAvailable: 'из {{max}}',
        showOther: 'Показать «{{section}}»: {{count}}',
        allMaterials: 'Все материалы',
        allDeposits: 'Все типы месторождений',
        analyte: 'Элемент',
        allAnalytes: 'Все элементы',
        addAnalyte: 'Добавить элемент',
        removeAnalyte: 'Убрать {{analyte}}',
        matchAnalytes: 'В продукте должны быть',
        matchAll: 'Все из них',
        matchAny: 'Любой из них',
        least: 'мин',
        most: 'макс',
        valueColumn: 'Сертифицированное значение {{n}}',
        sortBy: 'Сортировать по',
        sortUp: 'По возрастанию',
        sortDown: 'По убыванию',
        language: 'Язык',
        clear: 'Сбросить фильтры',
        noMatch: 'Нет продуктов по этим фильтрам.',
        emptyInStock: 'Сейчас ничего нет в наличии.',
        emptyIncoming: 'Сейчас поступлений не ожидается.',
        loading: 'Загрузка…',
        unavailable: 'Список сейчас недоступен.',
        need: 'Нужно',
        needOf: 'Количество {{code}}',
        tickOf: 'Выбрать {{code}}',
        contact: 'Связаться',
        contactTitle: 'Связаться по поводу {{code}}',
        requestTitle: 'Отправить запрос',
        selected_one: 'Выбрано продуктов: {{count}}',
        selected_other: 'Выбрано продуктов: {{count}}',
        send: 'Отправить',
        sending: 'Отправка…',
        cancel: 'Отмена',
        sent: 'Мы получили ваш запрос. Наши сотрудники свяжутся с вами.',
        field: {
          name: 'Имя',
          company: 'Компания',
          phone: 'Телефон',
          email: 'Эл. почта',
          registration: 'Регистрационный номер',
          address: 'Адрес для счёта',
          note: 'Примечание',
        },
        error: {
          name: 'Введите имя.',
          company: 'Введите название компании.',
          phone: 'Введите номер телефона, например 99112233.',
          email: 'Введите адрес эл. почты, например name@company.mn.',
          quantity: 'Введите целое число не меньше 1.',
          tooMany: 'Доступно не более {{max}}.',
          gone: '{{code}} больше нет в списке. Уберите его, чтобы продолжить.',
          noLines: 'Выберите хотя бы один продукт.',
          busy: 'Отправлено слишком много запросов. Подождите минуту и повторите.',
          refused: 'Запрос отклонён. Проверьте поля и повторите.',
          failed: 'Не удалось отправить запрос ({{status}}). Повторите попытку.',
        },
      },
    },
  },
}
